import { render, staticRenderFns } from "./CalendarSVG.vue?vue&type=template&id=4000c390&"
import script from "./CalendarSVG.vue?vue&type=script&lang=js&"
export * from "./CalendarSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports